import { Typography, Paper, Divider } from '@mui/material'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import { useTranslation } from 'react-i18next'

const CheckRepet = ({ repetCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = repetCheck?.checkDetails?.items ? repetCheck?.checkDetails?.items : []
  const hasChecks = Array.isArray(details) && details.length > 0
  const checkLength = details?.length || 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>Repet</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={repetCheck?.email}
        status={repetCheck?.status}
        createdAt={repetCheck?.createdAt}
        updatedAt={repetCheck?.updatedAt}
      />

      {hasChecks ? (
        details.map((item, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Nombre</Typography>
                  <Typography variant="subtitle3">{item.firstName || '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Tipo de Lista</Typography>
                  <Typography variant="subtitle3">{item.unListType || '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Número de Referencia</Typography>
                  <Typography variant="subtitle3">{item.referenceNumber || '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Listado el</Typography>
                  <Typography variant="subtitle3">
                    {item.listedOn ? new Date(item.listedOn).toLocaleDateString() : '---'}
                  </Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Comentarios</Typography>
                  <Typography variant="subtitle3">{item.comments || '---'}</Typography>
                </div>
                {item.lastDayUpdated?.length > 0 && (
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Última actualización</Typography>
                    <Typography variant="subtitle3">{item.lastDayUpdated[0]?.value || '---'}</Typography>
                  </div>
                )}
              </div>

              <Divider sx={{ my: 2 }} />

              <div className="c-detail-grid">
                <div className="c-detail-col">
                  <Typography variant="subtitle1">Alias</Typography>
                  {(item.entityAlias || []).map((alias, aliasIndex) => (
                    <Typography key={aliasIndex} variant="subtitle3">
                      {alias.quality || '---'}: {alias.aliasName || '---'}
                    </Typography>
                  ))}
                </div>

                <div className="c-detail-col">
                  <Typography variant="subtitle1">Direcciones</Typography>
                  {(item.entityAddress || []).map((address, addressIndex) => {
                    const full = address.street?.trim()
                    return (
                      <Typography key={addressIndex} variant="subtitle3">
                        {full
                          ? `${full}, ${address.city || '---'}, ${address.country || '---'}`
                          : 'Dirección no especificada.'}
                      </Typography>
                    )
                  })}
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))
      ) : (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">No se encontraron coincidencias.</Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckRepet

/* import { Box, Typography, Divider } from '@mui/material'
import CheckDetailTitle from './components/CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckRepet = ({ title = '', repetCheck, level = 0 }) => {
  const details = repetCheck?.checkDetails?.items

  return (
    <Box className="detail-group" sx={{ padding: '2rem' }}>
      <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1.5rem' }}>
        {title || 'Repet'}
      </Typography>

      <CheckDetailTitle
        email={repetCheck?.email}
        status={repetCheck?.status}
        createdAt={repetCheck?.createdAt}
        updatedAt={repetCheck?.updatedAt}
      />

      <Typography variant="h4" sx={{ fontSize: '1.25rem', marginBottom: '1rem' }}>
        Resultados
      </Typography>

      {details?.length > 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem',
          }}
        >
          {details.map((item, index) => (
            <Box
              key={index}
              sx={{
                padding: '1.5rem',
                border: '0.1rem solid',
                borderColor: 'grey.300',
                borderRadius: '0.8rem',
                backgroundColor: 'grey.50',
              }}
            >
              <Typography variant="body1" sx={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
                <strong>Nombre:</strong> {item.firstName || '---'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Tipo de Lista:</strong> {item.unListType || '---'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Número de Referencia:</strong> {item.referenceNumber || '---'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Listado el:</strong> {item.listedOn ? new Date(item.listedOn).toLocaleDateString() : '---'}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Comentarios:</strong> {item.comments || '---'}
              </Typography>
              {item.lastDayUpdated?.length > 0 && (
                <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                  <strong>Última actualización:</strong> {item.lastDayUpdated[0]?.value || '---'}
                </Typography>
              )}
              <Divider sx={{ margin: '1rem 0' }} />
              <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Alias:</strong>
              </Typography>
              {item.entityAlias.map((alias, aliasIndex) => (
                <Typography key={aliasIndex} variant="body2" sx={{ fontSize: '1rem' }}>
                  {alias.quality || '---'}: {alias.aliasName || '---'}
                </Typography>
              ))}
              <Divider sx={{ margin: '1rem 0' }} />
              <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Direcciones:</strong>
              </Typography>
              {item.entityAddress?.map((address, addressIndex) =>
                address.street && address.street.trim() !== '' ? (
                  <Typography key={addressIndex} variant="body2" sx={{ fontSize: '1rem' }}>
                    {address.street.trim()}, {address.city || '---'}, {address.country || '---'}
                  </Typography>
                ) : (
                  <Typography key={addressIndex} variant="body2" sx={{ fontSize: '1rem' }}>
                    Dirección no especificada.
                  </Typography>
                ),
              )}
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body1" sx={{ fontSize: '1rem' }}>
          No se encontraron coincidencias.
        </Typography>
      )}
    </Box>
  )
}

export default CheckRepet
 */
